import {
  FETCH_COHORTS_BY_SCHOOL_DOCUMENT_IDS,
  FetchCohortsBySchoolDocumentIdsQuery,
  FetchCohortsBySchoolDocumentIdsQueryVariables,
} from '@edwin-group/cj-graphql';
import { useReportingToolsStore } from '../../store/useReportingToolsStore';
import { useSuspenseQuery } from '@apollo/client';
import { MultiSelect, MultiSelectOption } from '@/components/ui/multi-select';
import { Error } from '../error';
import { useMemo } from 'react';

export const CohortsFilter = () => {
  const filters = useReportingToolsStore((state) => state.filters);
  const updateFilters = useReportingToolsStore((state) => state.updateFilters);
  const page = useReportingToolsStore((state) => state.page);
  const { data, error } = useSuspenseQuery<
    FetchCohortsBySchoolDocumentIdsQuery,
    FetchCohortsBySchoolDocumentIdsQueryVariables
  >(FETCH_COHORTS_BY_SCHOOL_DOCUMENT_IDS, {
    fetchPolicy: 'cache-and-network',
    variables: {
      academicYear: filters.academicYear,
      schoolDocumentIds: filters.schoolDocumentIds,
    },
    errorPolicy: 'all',
  });

  const cohorts = useMemo(() => data?.fetchCohortsBySchoolDocumentIds || [], [data]);

  const cohortOptions: MultiSelectOption[] = useMemo(
    () =>
      cohorts.map((cohort) => ({
        value: cohort?.documentId || '',
        label: cohort?.name || '',
      })),
    [cohorts],
  );

  if (error) {
    return <Error error={error} />;
  }

  return (
    <div className="grow">
      <label className="text-sh-xxs font-bold" htmlFor="cohorts-filter">
        {page?.filters?.cohorts || ''}
      </label>
      <MultiSelect
        options={cohortOptions}
        value={filters.cohortDocumentIds}
        onValueChange={(selectedCohorts) => {
          updateFilters({
            ...filters,
            cohortDocumentIds: selectedCohorts,
          });
        }}
        placeholder={page?.filters?.cohortsPlaceholder || ''}
      />
    </div>
  );
};
